__turbopack_context__.v({
  "buttonView": "wPZLba_buttonView",
  "buttonViewIcon": "wPZLba_buttonViewIcon",
  "charNice": "wPZLba_charNice",
  "isActive": "wPZLba_isActive",
  "isColumn": "wPZLba_isColumn",
  "item": "wPZLba_item",
  "list": "wPZLba_list",
  "listControl": "wPZLba_listControl",
  "listControlButton": "wPZLba_listControlButton",
  "listControlIconBottom": "wPZLba_listControlIconBottom",
  "listControlIconTop": "wPZLba_listControlIconTop",
  "listWrap": "wPZLba_listWrap",
  "markIcon": "wPZLba_markIcon",
  "niceSwitch": "wPZLba_niceSwitch",
  "search": "wPZLba_search",
  "searchIcon": "wPZLba_searchIcon",
  "searchInput": "wPZLba_searchInput",
  "searchInputContainer": "wPZLba_searchInputContainer",
  "selectAll": "wPZLba_selectAll",
  "selectAllMark": "wPZLba_selectAllMark",
  "selectedWord": "wPZLba_selectedWord",
  "selectedWordsCollapse": "wPZLba_selectedWordsCollapse",
  "selectedWordsExpandButton": "wPZLba_selectedWordsExpandButton",
  "selectedWordsList": "wPZLba_selectedWordsList",
  "settings": "wPZLba_settings",
  "settingsRight": "wPZLba_settingsRight",
});
